import { pathOr } from 'ramda';
import { SET_EXPERIMENT } from '../../constants/experiment';
import type { Nullable } from '../../../types';
import type { RootState } from '../../store';

export interface ExperimentState {
  id: Nullable<string>;
  value: Nullable<string>;
}

export const initialState: ExperimentState = {
  id: null, // experimentId
  value: null, // variationId
};

const experiment = (
  state = initialState,
  { type, payload }: { type: string; payload: ExperimentState }
): ExperimentState => {
  if (type === SET_EXPERIMENT) {
    return { ...state, ...payload };
  }

  return state;
};

export default experiment;

export const experimentIdSelector = (state: RootState) =>
  pathOr(initialState.id, ['app', 'experiment', 'id'], state);

export const experimentVariationIdSelector = (state: RootState) =>
  pathOr(initialState.value, ['app', 'experiment', 'value'], state);
